import React from 'react';

import { Section } from './Section';
import { UL } from './UL';
import { LI } from './LI';
import { ExternalLink } from './ExternalLink';

export const LE2_4 = () => (
  <Section>
    <UL>

      <LI>
        Vorformulierte Fragen unterstützen die SuS, sich den einzelnen Facetten des Themas zu nähern. Spielen Sie den Beitrag ggf. mehrmals vor:
        <UL disc>
          <LI>Warum gelten Instagram-Auftritte der Influencerin als Schleichwerbung?</LI>
          <LI>Wie begründet der Verband Sozialer Wettbewerb seine Klage?</LI>
          <LI>Wie rechtfertigt Pamela Reif ihr Handeln?</LI>
          <LI>Woraus ergibt sich der unlautere Wettbewerb?</LI>
          <LI>Warum können Influencer nicht einfach strittige Posts als Werbung markieren?</LI>
        </UL>
      </LI>

      <LI gapBefore>
        <b>Recherche</b>: Wie unterscheiden sich die Urteile in den Fällen Pamela Reif und Cathy Hummels? Warum?
        <br />
        <ExternalLink href="https://www.sueddeutsche.de/muenchen/cathy-hummels-prozess-schleichwerbung-1.4426365" />
      </LI>

      <LI gapBefore>
        Erweitern Sie die Mind-Map mit neuen Begriffen, die den SuS jetzt einfallen.
      </LI>

    </UL>
  </Section>
);



// WEBPACK FOOTER //
// ./src/components/LE/LE2_4.js